import { render, staticRenderFns } from "./proceedingsImpr.vue?vue&type=template&id=59b09032"
import script from "./proceedingsImpr.vue?vue&type=script&lang=js"
export * from "./proceedingsImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b09032')) {
      api.createRecord('59b09032', component.options)
    } else {
      api.reload('59b09032', component.options)
    }
    module.hot.accept("./proceedingsImpr.vue?vue&type=template&id=59b09032", function () {
      api.rerender('59b09032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsImpr.vue"
export default component.exports